/**
 * Is not part of the exported helpers.
 * This because it causes webpack errors as an npm package.
 * "Cannot read properties of undefined (reading 'Descending')"
 */
export enum SortOrder {
  Ascending = "ASC",
  Descending = "DESC",
}
